var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotEnrolled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 288,
    viewBox: "0 0 289 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 144,
    r: 101.426,
    stroke: "#FEBB25",
    strokeWidth: 0.816917
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 144,
    r: 143.592,
    stroke: "#FEBB25",
    strokeWidth: 0.816917
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.546,
    cy: 40.6204,
    r: 2.27473,
    fill: "#8981AE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.2742,
    cy: 109.284,
    r: 2.27473,
    fill: "#FFC861"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.749,
    cy: 182.896,
    r: 2.27473,
    fill: "#FFE7BB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3201,
    cy: 249.245,
    r: 1.62481,
    fill: "#534DE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.73 102.003C209.198 101.12 208.648 100.253 208.069 99.4046C200.389 88.1214 187.605 80.3966 175.182 76.899C169.739 75.363 164.152 74.5598 158.574 74.355C121.986 73.027 108.542 103.193 96.7536 110.973C84.9648 118.752 66.872 132.038 69.144 159.949C70.8656 181.171 82.9392 201.462 104.987 210.694C107.416 211.715 109.966 212.601 112.638 213.334C117.608 214.701 122.994 215.561 128.798 215.817C145.467 216.56 159.003 212.541 172.242 202.422C175.32 200.07 178.379 197.417 182.373 197.126C185.275 196.915 188.027 197.958 184.994 200.765C181.429 204.061 185.541 210.547 194.597 206.041C209.717 198.515 215.938 182.278 218.869 165.769C222.466 145.504 220.722 120.301 209.73 102.003Z",
    fill: "#E5E4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.005 81.2319H194.706V112.211H220.005V81.2319Z",
    fill: "#ADADAD",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.696 82.835H196.014V110.608H218.696V82.835Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.427 90.5117H202.283V102.931H212.427V90.5117Z",
    fill: "#ADADAD",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.994 74.7231H98.152V193.242H144.994V74.7231Z",
    fill: "#ADADAD",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.051 135.415H122.651V151.168H139.051V135.415Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.051 99.856H122.651V115.61H139.051V99.856Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.051 153.194H122.651V168.947H139.051V153.194Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.051 81.9072H122.651V97.8304H139.051V81.9072Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.498 81.9072H104.098V97.8304H120.498V81.9072Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.051 117.635H122.651V133.389H139.051V117.635Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.498 117.635H104.098V133.389H120.498V117.635Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.051 170.976H122.651V184.384H139.051V170.976Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.498 153.194H104.098V168.947H120.498V153.194Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.498 170.976H104.098V184.384H120.498V170.976Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.498 135.415H104.098V151.168H120.498V135.415Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.498 99.856H104.098V115.61H120.498V99.856Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.638 74.9634V193.136",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.994 193.245H191.835L191.835 74.7267H144.994V193.245Z",
    fill: "#ADADAD",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.339 135.415H150.939V151.168H167.339V135.415Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.339 99.856H150.939V115.61H167.339V99.856Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.339 153.194H150.939V168.947H167.339V153.194Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.339 81.9072H150.939V97.8304H167.339V81.9072Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.893 81.9072H169.493V97.8304H185.893V81.9072Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.339 117.635H150.939V133.389H167.339V117.635Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.893 117.635H169.493V133.389H185.893V117.635Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.339 170.976H150.939V184.384H167.339V170.976Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.893 153.194H169.493V168.947H185.893V153.194Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.893 170.976H169.493V184.384H185.893V170.976Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.893 135.415H169.493V151.168H185.893V135.415Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.893 99.856H169.493V115.61H185.893V99.856Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.352 74.9634V193.136",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.466 178.115H84.632L86.216 199.229H98.8816L100.466 178.115Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6208 135.113V181.321L93.24 179.702V152.825L98.2512 140.982L92.9296 150.915L92.7312 136.576L91.6208 135.113Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.472 133.075L79.2528 127.239L84.7824 133.229L75.8736 131.079L82.1712 134.151H71.4192L80.328 135.536L69.8832 137.533L78.3312 137.226L70.4976 140.451L78.9456 139.069L67.7328 146.749L81.096 140.298L74.0304 147.363L80.4816 143.216L75.8736 151.357L82.632 143.523L79.2528 150.589L85.2464 143.063V148.285L88.0112 141.987V145.52L90.776 138.147V141.834L92.7312 136.576L93.2336 135.229L87.2432 127.085L89.0864 132L87.2432 130.464L88.472 133.075Z",
    fill: "#FAA037"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.304 147.526L76.4784 148.87L84.5552 149.987L76.3056 153.984L83.1216 152.358L74.8176 159.187L82.5776 154.595L75.7776 162.771L82.1072 157.168L78.104 164.636L83.752 158.201L79.9696 171.257L86.1936 157.785L85.224 167.731L87.5728 160.432L89.1824 169.644L89.4288 159.302L91.3072 166.905L91.1536 157.289L94.4688 161.321L92.6064 154.7L94.8496 157.43L92.3024 149.98L94.6448 152.825L92.8176 147.526L92.3472 146.163L82.552 143.68L87.096 146.307L84.696 146.291L87.304 147.526Z",
    fill: "#FAA037"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.304 147.526L76.4784 148.87L84.5552 149.987L76.3056 153.984L83.1216 152.358L74.8176 159.187L82.5776 154.595L75.7776 162.771L82.1072 157.168L78.104 164.636L83.752 158.201L79.9696 171.257L86.1936 157.785L85.224 167.731L87.5728 160.432L89.1824 169.644L89.4288 159.302L91.3072 166.905L91.1536 157.289L94.4688 161.321L92.6064 154.7L94.8496 157.43L92.3024 149.98L94.6448 152.825L92.8176 147.526L92.3472 146.163L82.552 143.68L87.096 146.307L84.696 146.291L87.304 147.526Z",
    fill: "#FAA037"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1696 130.253L111.483 128.24L101.538 132.451L113.464 134.72L104.184 134.989L117.163 140.861L105.656 137.664L117.173 145.779L107.144 140.794L114.837 148.963L105.394 142.682L114.734 158.077L102.126 142.992L106.798 155.379L101.275 146.851L102.392 159.194L98.5136 146.048L98.7344 156.419L95.6112 144.064L92.76 150.368L92.8624 141.258L90.9328 145.52L91.6208 135.114L89.608 139.562L90.12 132.15L90.2512 130.246L101.925 123.693L97.016 128.621L100.082 127.773L97.1696 130.253Z",
    fill: "#FAA037"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3136 127.731L101.15 118.515L95.16 124.045L97.3104 115.136L94.2384 121.434V110.682L92.856 119.59L90.8592 109.146L91.1664 117.594L87.9408 109.76L89.3232 118.208L81.6432 106.995L88.0944 120.358L81.0288 113.293L85.176 119.744L77.0352 115.136L84.8688 121.894L77.8032 118.515L85.3296 124.506H80.1072L86.4048 127.27H82.872L90.2448 130.035H86.5584L91.8128 131.99L93.1632 132.493L101.304 126.502L96.3888 128.346L97.9248 126.502L95.3136 127.731Z",
    fill: "#FAA037"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.093 136.134C152.405 132.211 149.906 129.904 149.906 129.904C146.866 128.138 144.462 130.099 144.462 130.099C144.462 130.099 142.059 128.138 139.019 129.904C139.019 129.904 136.517 132.208 135.832 136.134C135.144 140.058 137.842 141.776 137.842 141.776H151.086C151.086 141.776 153.784 140.061 153.096 136.134H153.093Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.811 140.521C154.811 140.521 160.472 140.009 162.622 143.696C164.773 147.379 170.709 164.268 170.197 165.19C169.685 166.112 166.002 166.112 164.67 165.088C163.339 164.064 157.301 153.83 157.301 153.83L154.814 140.524L154.811 140.521Z",
    fill: "#F7DBC6",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M156.12 145.241C156.12 145.241 158.517 151.494 159.032 156.547L157.301 153.83L156.12 145.241Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.093 173.891C158.098 170.819 155.01 164.576 155.01 164.166C155.01 163.757 157.598 156.182 157.598 152.806C157.598 149.43 154.811 140.525 154.811 140.525C154.811 140.525 150.552 139.827 149.57 138.714C148.587 137.6 148.744 132.026 148.744 132.026L144.453 131.52L140.162 132.026C140.162 132.026 140.315 137.6 139.336 138.714C138.354 139.827 134.094 140.525 134.094 140.525C134.094 140.525 131.307 149.43 131.307 152.806C131.307 156.182 133.896 163.76 133.896 164.166C133.896 164.573 130.808 170.819 129.813 173.891C128.818 176.963 127.922 182.899 127.822 185.661L144.456 195.795L161.09 185.661C160.99 182.896 160.094 176.96 159.099 173.891H159.093Z",
    fill: "#F7DBC6",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.65 134.617L148.344 135.574L148.238 131.9L143.65 134.617Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.835 141.776C137.835 141.776 142.162 141.545 143.045 141.609",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M151.08 141.776L146.523 141.504C146.523 141.504 145.365 141.715 145.365 142.451",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.91 116.627C150.453 115.955 149.861 115.443 149 114.982C148.258 114.585 147.451 114.301 146.635 114.083C143.861 113.337 139.24 113.971 137.666 116.637C136.354 118.857 136.254 119.737 136.498 121.805C136.741 123.872 138.053 131.104 139.221 132.345C140.389 133.587 143.016 134.617 143.646 134.617H144.91C145.544 134.617 148.168 133.584 149.336 132.345C150.504 131.104 151.816 123.872 152.059 121.805C152.216 120.47 152.059 119.129 151.554 117.875C151.362 117.401 151.154 116.992 150.907 116.627H150.91Z",
    fill: "#F7DBC6",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.829 124.07C139.829 124.07 141.298 124.778 142.818 123.798",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M143.144 120.861C143.144 120.861 140.696 119.501 139.339 121.677",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M149.125 124.07C149.125 124.07 147.656 124.778 146.136 123.798",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M145.806 120.861C145.806 120.861 148.254 119.501 149.611 121.677",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M145.806 122.166C145.806 122.166 144.99 124.505 145.317 124.723C145.643 124.94 146.078 125.43 145.861 126.028C145.643 126.627 145.099 126.79 144.936 126.79",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M145.157 129.507C145.157 129.808 144.949 130.051 144.696 130.051C144.443 130.051 144.235 129.808 144.235 129.507C144.235 129.206 144.443 128.963 144.696 128.963C144.949 128.963 145.157 129.206 145.157 129.507Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M151.56 118.086C151.368 117.587 151.16 117.155 150.914 116.774C150.456 116.067 149.864 115.529 149.003 115.046C148.261 114.63 147.454 114.329 146.638 114.099C144.149 113.395 140.882 113.782 138.83 115.44C136.568 117.267 135.909 120.918 136.76 123.59C137.176 123.421 137.464 122.979 137.451 122.531C137.435 121.92 136.926 121.392 136.942 120.781C136.958 120.192 137.442 119.741 137.8 119.273C138.664 118.147 138.978 116.553 140.178 115.795C140.853 115.366 141.698 115.296 142.494 115.341C143.16 115.379 143.819 115.497 144.488 115.507C145.042 115.513 145.534 115.334 146.085 115.293C147.179 115.213 148.302 115.638 148.984 116.515C149.829 117.603 150.229 119.017 151.074 119.885C151.918 120.755 151.224 121.408 150.974 122.333C150.76 123.129 151.618 123.603 151.858 123.718C151.954 123.107 152.024 122.589 152.066 122.224C152.222 120.822 152.066 119.411 151.56 118.089V118.086Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M136.757 123.587C136.757 123.587 135.966 122.874 135.314 123.578C134.661 124.285 135.096 125.808 135.477 126.458C135.858 127.107 137.598 127.872 137.598 127.872L136.757 123.584V123.587Z",
    fill: "#F7DBC6",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M151.922 123.587C151.922 123.587 152.75 122.915 153.362 123.657C153.973 124.4 153.458 125.894 153.042 126.525C152.626 127.155 150.952 127.757 150.952 127.757L151.922 123.584V123.587Z",
    fill: "#F7DBC6",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M127.819 185.661L147.115 198.048L161.083 185.661C161.006 183.507 160.443 179.424 159.726 176.275C142.661 178.419 132.395 176.992 129.147 176.381C128.443 179.517 127.893 183.529 127.816 185.661H127.819Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128.946 177.354C144.235 180.067 156.35 177.901 159.915 177.114C159.662 175.898 159.384 174.774 159.096 173.891C158.101 170.819 155.013 164.576 155.013 164.166C155.013 163.757 157.602 156.182 157.602 152.806C157.602 149.43 154.814 140.525 154.814 140.525C154.814 140.525 153.602 140.326 152.322 139.971C152.392 142.979 152.069 153.661 143.794 152.602C135.688 151.568 136.373 142.688 136.789 139.914C135.438 140.304 134.101 140.522 134.101 140.522C134.101 140.522 131.314 149.427 131.314 152.803C131.314 156.179 133.902 163.757 133.902 164.163C133.902 164.57 130.814 170.816 129.819 173.888C129.515 174.829 129.218 176.042 128.952 177.35L128.946 177.354Z",
    fill: "#534DE0",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M138.2 163.523L151.16 158.467",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.213 160.362L145.787 161.943",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M134.094 140.521C134.094 140.521 129.56 139.907 126.386 143.184C123.211 146.46 117.787 155.26 117.787 156.694C117.787 158.128 121.675 158.435 124.133 157.206C126.59 155.977 131.605 149.427 131.605 149.427L134.091 140.521H134.094Z",
    fill: "#F7DBC6",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M165.323 160.022C165.006 160.006 163.326 160.957 161.851 161.91C159.966 163.129 154.344 167.238 151.989 167.645C149.634 168.054 148.712 167.849 148.712 167.849C148.712 167.849 145.934 166.621 145.218 166.518C144.501 166.416 143.31 166.771 142.338 166.934C141.365 167.097 140.715 166.854 140.757 167.136C140.798 167.421 140.837 167.865 141.486 168.029C142.136 168.192 143.109 168.109 143.109 168.109C143.109 168.109 144.082 168.15 144.245 168.189C144.408 168.23 137.877 171.229 137.877 171.229C137.877 171.229 137.797 171.392 138.078 171.552C138.363 171.715 141.448 171.075 141.448 171.075L141.566 171.43C141.566 171.43 137.39 173.254 137.307 173.417C137.227 173.581 137.266 173.945 137.55 173.945C137.835 173.945 141.8 172.701 141.8 172.701L141.89 173.094C141.89 173.094 138.728 175.161 138.645 175.283C138.565 175.405 138.645 175.769 138.93 175.728C139.214 175.686 142.578 174.269 142.578 174.269L142.715 174.518C142.715 174.518 140.872 176.297 140.914 176.461C140.955 176.624 141.198 176.825 141.442 176.662C141.685 176.499 144.443 174.998 144.443 174.998C144.443 174.998 148.376 173.456 148.619 173.376C148.862 173.296 151.579 171.59 151.579 171.59C151.579 171.59 160.421 170.416 164.149 168.55C167.88 166.685 170.139 166.032 170.187 165.184C170.232 164.336 169.339 161.901 169.339 161.901",
    fill: "#F7DBC6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M165.323 160.022C165.006 160.006 163.326 160.957 161.851 161.91C159.966 163.129 154.344 167.238 151.989 167.645C149.634 168.054 148.712 167.849 148.712 167.849C148.712 167.849 145.934 166.621 145.218 166.518C144.501 166.416 143.31 166.771 142.338 166.934C141.365 167.097 140.715 166.854 140.757 167.136C140.798 167.421 140.837 167.865 141.486 168.029C142.136 168.192 143.109 168.109 143.109 168.109C143.109 168.109 144.082 168.15 144.245 168.189C144.408 168.23 137.877 171.229 137.877 171.229C137.877 171.229 137.797 171.392 138.078 171.552C138.363 171.715 141.448 171.075 141.448 171.075L141.566 171.43C141.566 171.43 137.39 173.254 137.307 173.417C137.227 173.581 137.266 173.945 137.55 173.945C137.835 173.945 141.8 172.701 141.8 172.701L141.89 173.094C141.89 173.094 138.728 175.161 138.645 175.283C138.565 175.405 138.645 175.769 138.93 175.728C139.214 175.686 142.578 174.269 142.578 174.269L142.715 174.518C142.715 174.518 140.872 176.297 140.914 176.461C140.955 176.624 141.198 176.825 141.442 176.662C141.685 176.499 144.443 174.998 144.443 174.998C144.443 174.998 148.376 173.456 148.619 173.376C148.862 173.296 151.579 171.59 151.579 171.59C151.579 171.59 160.421 170.416 164.149 168.55C167.88 166.685 170.139 166.032 170.187 165.184C170.232 164.336 169.339 161.901 169.339 161.901",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M119.64 153.203C119.64 153.203 123.829 150.893 129.317 149.062C134.805 147.232 138.366 146.077 141.688 144.585C145.01 143.094 144.53 143.574 144.674 143.574C144.818 143.574 148.91 144.441 149.198 144.489C149.486 144.537 153.675 146.029 153.675 146.029C153.675 146.029 153.723 146.461 153.339 146.608L152.955 146.752C152.955 146.752 152.715 147.184 152.328 147.232C151.944 147.28 151.029 147.424 150.885 147.424C150.741 147.424 150.162 147.712 149.586 147.856C149.01 148 148.382 148.144 148.046 148.192C147.71 148.24 146.024 148.336 146.024 148.336C146.024 148.336 144.677 148.672 143.23 148.72C141.787 148.768 139.957 148.528 139.957 148.528C139.957 148.528 125.851 158.349 124.117 159.36C122.382 160.371 120.603 161.43 119.157 161.046C117.714 160.662 116.702 160.179 116.942 158.976C117.182 157.773 117.762 155.27 119.637 153.2L119.64 153.203Z",
    fill: "#F7DBC6",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M145.346 144.537C145.346 144.537 148.379 144.921 149.147 144.969C149.918 145.017 153.672 146.028 153.672 146.028",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M145.589 145.741L150.114 145.936L152.952 146.752",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M145.538 146.848L147.947 146.995L150.882 147.427",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M151.378 193.126C151.378 193.126 155.835 186.844 160.034 183.974C164.232 181.104 172.978 178.681 180.178 181.552C187.378 184.422 192.606 191.42 193.205 192.409C193.803 193.395 193.291 195.728 192.434 196.896C191.576 198.064 189.435 199.228 188.318 199.228H136.037C136.037 199.228 135.781 198.243 136.638 197.433C137.496 196.627 142.552 194.921 143.582 194.384C144.61 193.846 145.81 190.614 147.784 189.987C149.758 189.36 151.384 193.126 151.384 193.126H151.378Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M183.637 199.229H136.178C136.178 199.229 135.922 198.243 136.773 197.433C137.621 196.627 142.629 194.921 143.65 194.384C144.667 193.846 145.858 190.614 147.81 189.987C149.762 189.36 151.374 193.126 151.374 193.126C151.374 193.126 151.883 193.843 152.734 194.342C153.582 194.841 155 195.389 155.282 195.389C155.563 195.389 161.653 194.592 164.766 193.094C167.88 191.6 172.363 188.608 175.995 188.208C179.627 187.808 182.6 189.603 184.44 190.899",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M183.637 199.229H136.178C136.178 199.229 135.922 198.243 136.773 197.433C137.621 196.627 142.629 194.921 143.65 194.384C144.667 193.846 145.858 190.614 147.81 189.987C149.762 189.36 151.374 193.126 151.374 193.126C151.374 193.126 151.883 193.843 152.734 194.342C153.582 194.841 155 195.389 155.282 195.389C155.563 195.389 161.653 194.592 164.766 193.094C167.88 191.6 172.363 188.608 175.995 188.208C179.627 187.808 182.6 189.603 184.44 190.899",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M185.854 192.396C185.854 192.396 184.392 194.041 182.978 194.291C181.563 194.54 176.466 193.744 174.766 193.344",
    stroke: "white",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M155.278 195.389C155.56 195.389 161.65 194.592 164.763 193.094C167.877 191.6 172.36 188.608 175.992 188.208C179.624 187.808 182.597 189.603 184.437 190.899",
    stroke: "white",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M155.176 195.376L154.776 199.229H136.178C136.178 199.229 135.922 198.243 136.773 197.433C137.621 196.627 142.629 194.921 143.65 194.384C144.667 193.846 145.858 190.614 147.81 189.987C149.762 189.36 151.374 193.126 151.374 193.126C151.374 193.126 151.883 193.843 152.734 194.342C153.509 194.797 154.75 195.293 155.179 195.376H155.176Z",
    fill: "#F7DBC6",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M141.861 193.126C141.861 193.126 137.195 186.844 132.798 183.974C128.402 181.104 119.25 178.681 111.714 181.552C104.178 184.422 98.7056 191.42 98.0752 192.409C97.448 193.395 97.9856 195.728 98.8816 196.896C99.7776 198.06 102.021 199.228 103.189 199.228H157.918C157.918 199.228 158.187 198.243 157.291 197.433C156.395 196.627 151.099 194.921 150.024 194.384C148.949 193.846 147.691 190.614 145.627 189.987C143.563 189.36 141.858 193.126 141.858 193.126H141.861Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M107.762 199.229H157.918C157.918 199.229 158.187 198.243 157.291 197.433C156.395 196.627 151.099 194.921 150.024 194.384C148.949 193.846 147.691 190.614 145.627 189.987C143.563 189.36 141.858 193.126 141.858 193.126C141.858 193.126 141.32 193.843 140.421 194.342C139.522 194.841 138.027 195.389 137.73 195.389C137.432 195.389 130.997 194.592 127.707 193.094C124.414 191.6 119.678 188.608 115.838 188.208C111.998 187.808 108.856 189.603 106.914 190.899",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M107.762 199.229H157.918C157.918 199.229 158.187 198.243 157.291 197.433C156.395 196.627 151.099 194.921 150.024 194.384C148.949 193.846 147.691 190.614 145.627 189.987C143.563 189.36 141.858 193.126 141.858 193.126C141.858 193.126 141.32 193.843 140.421 194.342C139.522 194.841 138.027 195.389 137.73 195.389C137.432 195.389 130.997 194.592 127.707 193.094C124.414 191.6 119.678 188.608 115.838 188.208C111.998 187.808 108.856 189.603 106.914 190.899",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M105.419 192.396C105.419 192.396 106.965 194.041 108.462 194.291C109.957 194.54 115.342 193.744 117.138 193.344",
    stroke: "white",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M137.73 195.389C137.432 195.389 130.997 194.592 127.707 193.094C124.414 191.6 119.678 188.608 115.838 188.208C111.998 187.808 108.856 189.603 106.914 190.899",
    stroke: "white",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M137.838 195.376L138.261 199.229H157.915C157.915 199.229 158.184 198.243 157.288 197.433C156.392 196.627 151.096 194.921 150.021 194.384C148.946 193.846 147.688 190.614 145.624 189.987C143.56 189.36 141.854 193.126 141.854 193.126C141.854 193.126 141.317 193.843 140.418 194.342C139.598 194.797 138.286 195.293 137.832 195.376H137.838Z",
    fill: "#F7DBC6",
    stroke: "#263238",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M129.125 182.528C129.125 182.528 135.47 184.31 140.962 189.657",
    stroke: "white",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M160.037 183.974C160.037 183.974 154.507 186.233 149.874 189.513",
    stroke: "white",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2096 199.229H217.781",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEnrolled);
export default __webpack_public_path__ + "static/media/not_enrolled.872fcdecd44c6a5af29bc4e00ed0b257.svg";
export { ForwardRef as ReactComponent };